import React from "react";
import { Row, Button, Typography, Layout, Col, Tag, Divider } from "antd";
import { DeleteFilled, MenuOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { removeNews } from "../../../../Redux/Slice/NewsSlice";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { dragNews } from "../../../../Redux/Slice/NewsSlice";
import { NewslistCard } from "./styles";

const { Text } = Typography;
const { Content } = Layout;

// Helper function to get the publication date from either fetched or reported news
const getPublicationDate = (article: any) => {
  return article?.articlePubDate || article?.created_at || "";
};

const DraggableNewsItem = ({ item, dispatch, showModal, index, moveItem }) => {
  const [{ isDragging }, drag] = useDrag({
    type: "NEWS_ITEM",
    item: { index },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: "NEWS_ITEM",
    hover: (draggedItem: any) => {
      if (draggedItem.index !== index) {
        moveItem(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  const truncateTitle = (title) => {
    if (title.length > 50) {
      return title.substring(0, 50) + "...";
    }
    return title;
  };

  return (
    <Content
      ref={(node) => drag(drop(node))}
      style={{ opacity: isDragging ? 0.5 : 1, overflowY: "auto" }}
    >
      <NewslistCard size="small">
        <Row>
          <Col span={2}>
            <MenuOutlined style={{ color: "grey" }} />
          </Col>
          <Col span={22}>
            <Row justify="space-between" align="top">
              <Text
                style={{
                  height: "30px",
                  width: "100%",
                  lineHeight: "1.2",
                  fontFamily: "Inria serif",
                }}
              >
                <strong>{truncateTitle(item.title)}</strong>
              </Text>
            </Row>

            <br></br>
            <Row justify="space-between" align="middle">
              <Text
                style={{
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                <strong style={{ fontSize: "14px" }}></strong> {item.source}
              </Text>
              <Tag style={{ fontFamily: "Inter" }} color="red">
                {item.genre}
              </Tag>
            </Row>
            <Divider style={{ margin: "8px 0" }} />

            <Content
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
              }}
            >
              <Row justify="space-between" style={{ height: "20px" }}>
                <Text
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    color: "grey",
                  }}
                >
                  {new Date(getPublicationDate(item)).toLocaleString()}
                </Text>
                <Button
                  onClick={() => {
                    dispatch(removeNews(item.article_id || item._id));
                  }}
                  style={{
                    fontSize: "14px",
                    color: "red",
                    display: "flex",
                    alignContent: "center",
                  }}
                  type="link"
                >
                  <DeleteFilled />
                </Button>
              </Row>
            </Content>
          </Col>
        </Row>
      </NewslistCard>
    </Content>
  );
};

const DrawerList = ({ drawerData, showModal }) => {
  const dispatch = useDispatch();

  const moveItem = (fromIndex, toIndex) => {
    const updatedData = [...drawerData];
    const [movedItem] = updatedData.splice(fromIndex, 1);
    updatedData.splice(toIndex, 0, movedItem);
    dispatch(dragNews(updatedData));
  };

  return (
    <>
      <Content>
        <DndProvider backend={HTML5Backend}>
          {drawerData?.map((item: any, index) => (
            <DraggableNewsItem
              key={item.article_id || item._id}
              item={item}
              index={index}
              dispatch={dispatch}
              showModal={showModal}
              moveItem={moveItem}
            />
          ))}
        </DndProvider>
      </Content>
    </>
  );
};

export default DrawerList;
